import createHTMLMediaHook from './factory/createHTMLMediaHook';
var useAudio = createHTMLMediaHook('audio');
export default useAudio;